module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.8933d5e8.jpg";